import { useLocation } from "react-router-dom";

export const useIsUnitPage = (): boolean => {
  const location = useLocation();
  return location.pathname.includes("/u/");
};
